// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/page/financial/Payment.css
// module id = 65
// module chunks = 0